export enum SupportedCountries {
    UNKNOWN = 0,
    BRAZIL = 12,
    UNITED_KINGDOM = 13,
    GERMANY = 18,
    SPAIN = 28,
    RUSSIA = 50,
    FRANCE = 64,
}
